import WideoObject from './WideoObject';
import { Class } from './model/WideoDef';
import VideoComponent from './components/VideoComponent';
import IMediaObject from './IMediaObject';

export default class VideoObject extends WideoObject implements IMediaObject {

  public getUrl(): string {
    const videoComponent = this.getComponentByClass(Class.VideoComponent) as VideoComponent;
    if (videoComponent) {
      return videoComponent.getSrc();
    }
    return null;
  }

  public getDuration = () => {
    const videoComponent: VideoComponent = this.getComponentByClass(Class.VideoComponent) as VideoComponent;
    return videoComponent.getDuration();
  }
  
  public static isVideoObject = (object: WideoObject): object is VideoObject => {
    return (object && object.getClass() === Class.VideoObject)
  }
}